import { useContext } from 'react';
import { CartSidebarUIStateContext } from './CartSidebarUIStateContext';

export function useCart() {
  return useContext(CartSidebarUIStateContext);
}
